
export default (data, resolve, self) => {
  resolve();
  setTimeout(() => {
    self.updateLangs();
  }, 0);
}
